//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @typedef {{ name: string, value: string, checked: boolean }} CheckboxValue
 */

export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: null,
        },
        /**
         * @property {string} values[].name
         * @property {string} values[].value
         * @property {boolean} values[].checked
         * @type {import('vue').PropOptions<CheckboxValue[]>}
         */
        values: {
            type: Array,
            required: true,
        },
        radio: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        error: {
            type: [Boolean, String],
            default: false,
        },
        success: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isClient: {
            type: Boolean,
            default: false,
        },
        horizontal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            keyboardInput: false,
        };
    },
    computed: {
        /** @return {string} */
        type() {
            return this.radio ? 'radio' : 'checkbox';
        },
        /** @return {boolean} */
        hasLabel() {
            return !!(this.error || this.label);
        },
        /** @return {boolean} */
        hasError() {
            return !!(typeof (this.error) === 'string' && this.error.length);
        },
    },
    methods: {
        /** @param {FocusEvent} e */
        blur(e) {
            const target = /** @type {HTMLInputElement} */(e.target);
            if (!this.keyboardInput) {
                if (target) {
                    target.blur();
                }
            }
            /**
             * @event selected
             * @property {string} name
             * @property {string | boolean} value
             */
            this.$emit('selected', {
                name: this.name,
                value: target.checked ? target.value : false,
            });
        },
        /** @param {FocusEvent} e */
        focus(e) {
            this.keyboardInput = e.relatedTarget !== null;
        },
    },
};
